import React, { useState, useEffect, ChangeEvent } from 'react';
 import {
  SlidersHorizontal,
  ArrowLeft,
  ArrowRight,
  Circle,
  Square,
  Shirt,
  ChevronDown,
  ChevronUp,
  Check,
  X,
 } from 'lucide-react';

import product from '../images/shop/product.png';
import { Link } from 'react-router-dom';

 // Sample product data (replace with your actual API calls)
 interface Product {
  id: number;
  name: string;
  imageUrl: string;
  price: number;
  discountedPrice?: number;
  rating: number;
  totalReviews: number;
  colorOptions?: string[];
  sizeOptions?: string[];
  category: 'Gaming' | 'Office' | 'School';
  GPU?: string;
 }

 const sampleProducts: Product[] = [
  {
   id: 1,
   name: 'Gradient Graphic T-shirt',
   imageUrl: product,
   price: 145,
   rating: 4.5,
   totalReviews: 25,
   colorOptions: ['#000000', '#f0f0f0'],
   sizeOptions: ['S', 'M', 'L'],
   category: 'Gaming',
   GPU: 'NVidia 2090',
  },
  {
   id: 2,
   name: 'Polo with Tipping Details',
   imageUrl: product,
   price: 180,
   rating: 4.8,
   totalReviews: 32,
   colorOptions: [],
   sizeOptions: ['M', 'L', 'XL'],
   category: 'Office',
   GPU: 'Amd 7800',
  },
  {
   id: 3,
   name: 'Black Striped T-shirt',
   imageUrl: product,
   price: 150,
   discountedPrice: 120,
   rating: 4.2,
   totalReviews: 18,
   colorOptions: ['#ffffff'],
   sizeOptions: ['S', 'M', 'L', 'XL'],
   category: 'Office',
   GPU: 'NVidia 4090',
  },
  {
   id: 4,
   name: 'Skinny Fit Jeans',
   imageUrl: product,
   price: 260,
   discountedPrice: 240,
   rating: 4.0,
   totalReviews: 45,
   sizeOptions: ['28', '30', '32', '34'],
   category: 'School',
   GPU: 'NVidia 5090',
  },
  {
   id: 5,
   name: 'Checkered Shirt',
   imageUrl: product,
   price: 180,
   rating: 4.5,
   totalReviews: 28,
   colorOptions: [],
   sizeOptions: ['S', 'M', 'L', 'XL'],
   category: 'School',
   GPU: 'AMD 7700',
  },
  {
   id: 6,
   name: 'Sleeve Striped T-shirt',
   imageUrl: product,
   price: 160,
   discountedPrice: 130,
   rating: 4.6,
   totalReviews: 22,
   colorOptions: [],
   sizeOptions: ['M', 'L', 'XL'],
   category: 'Office',
   GPU: 'AMD 7800',
  },
  {
   id: 7,
   name: 'Vertical Striped Shirt',
   imageUrl: product,
   price: 232,
   discountedPrice: 212,
   rating: 4.0,
   totalReviews: 15,
   colorOptions: [],
   sizeOptions: ['S', 'M', 'L'],
   category: 'Gaming',
   GPU: 'AMD 7900',
  },
  {
   id: 8,
   name: 'Courage Graphic T-shirt',
   imageUrl: product,
   price: 145,
   rating: 4.0,
   totalReviews: 10,
   colorOptions: [],
   sizeOptions: ['M', 'L'],
   category: 'Office',
   GPU: 'AMD 5600',
  },
  {
   id: 9,
   name: 'Loose Fit Bermuda Shorts',
   imageUrl: product,
   price: 80,
   rating: 3.8,
   totalReviews: 8,
   sizeOptions: ['30', '32', '34', '36'],
   category: 'Gaming',
   GPU: 'AMD 5800',
  },
  {
    id: 10,
    name: 'Gradient Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.5,
    totalReviews: 25,
    colorOptions: ['#000000', '#f0f0f0'],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'NVidia 2090',
  },
  {
    id: 11,
    name: 'Polo with Tipping Details',
    imageUrl: product,
    price: 180,
    rating: 4.8,
    totalReviews: 32,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Gaming',
    GPU: 'Amd 7800',
  },
  {
    id: 12,
    name: 'Black Striped T-shirt',
    imageUrl: product,
    price: 150,
    discountedPrice: 120,
    rating: 4.2,
    totalReviews: 18,
    colorOptions: ['#ffffff'],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'NVidia 4090',
  },
  {
    id: 13,
    name: 'Skinny Fit Jeans',
    imageUrl: product,
    price: 260,
    discountedPrice: 240,
    rating: 4.0,
    totalReviews: 45,
    sizeOptions: ['28', '30', '32', '34'],
    category: 'Office',
    GPU: 'NVidia 5090',
  },
  {
    id: 14,
    name: 'Checkered Shirt',
    imageUrl: product,
    price: 180,
    rating: 4.5,
    totalReviews: 28,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'AMD 7700',
  },
  {
    id: 15,
    name: 'Sleeve Striped T-shirt',
    imageUrl: product,
    price: 160,
    discountedPrice: 130,
    rating: 4.6,
    totalReviews: 22,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'School',
    GPU: 'AMD 7800',
  },
  {
    id: 16,
    name: 'Vertical Striped Shirt',
    imageUrl: product,
    price: 232,
    discountedPrice: 212,
    rating: 4.0,
    totalReviews: 15,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L'],
    category: 'School',
    GPU: 'AMD 7900',
  },
  {
    id: 17,
    name: 'Courage Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.0,
    totalReviews: 10,
    colorOptions: [],
    sizeOptions: ['M', 'L'],
    category: 'School',
    GPU: 'AMD 5600',
  },
  {
    id: 18,
    name: 'Loose Fit Bermuda Shorts',
    imageUrl: product,
    price: 80,
    rating: 3.8,
    totalReviews: 8,
    sizeOptions: ['30', '32', '34', '36'],
    category: 'Gaming',
    GPU: 'AMD 5800',
  },
  {
    id: 10,
    name: 'Gradient Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.5,
    totalReviews: 25,
    colorOptions: ['#000000', '#f0f0f0'],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'NVidia 2090',
  },
  {
    id: 11,
    name: 'Polo with Tipping Details',
    imageUrl: product,
    price: 180,
    rating: 4.8,
    totalReviews: 32,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Gaming',
    GPU: 'Amd 7800',
  },
  {
    id: 12,
    name: 'Black Striped T-shirt',
    imageUrl: product,
    price: 150,
    discountedPrice: 120,
    rating: 4.2,
    totalReviews: 18,
    colorOptions: ['#ffffff'],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'NVidia 4090',
  },
  {
    id: 13,
    name: 'Skinny Fit Jeans',
    imageUrl: product,
    price: 260,
    discountedPrice: 240,
    rating: 4.0,
    totalReviews: 45,
    sizeOptions: ['28', '30', '32', '34'],
    category: 'Office',
    GPU: 'NVidia 5090',
  },
  {
    id: 14,
    name: 'Checkered Shirt',
    imageUrl: product,
    price: 180,
    rating: 4.5,
    totalReviews: 28,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'AMD 7700',
  },
  {
    id: 15,
    name: 'Sleeve Striped T-shirt',
    imageUrl: product,
    price: 160,
    discountedPrice: 130,
    rating: 4.6,
    totalReviews: 22,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'School',
    GPU: 'AMD 7800',
  },
  {
    id: 16,
    name: 'Vertical Striped Shirt',
    imageUrl: product,
    price: 232,
    discountedPrice: 212,
    rating: 4.0,
    totalReviews: 15,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L'],
    category: 'School',
    GPU: 'AMD 7900',
  },
  {
    id: 17,
    name: 'Courage Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.0,
    totalReviews: 10,
    colorOptions: [],
    sizeOptions: ['M', 'L'],
    category: 'School',
    GPU: 'AMD 5600',
  },
  {
    id: 18,
    name: 'Loose Fit Bermuda Shorts',
    imageUrl: product,
    price: 80,
    rating: 3.8,
    totalReviews: 8,
    sizeOptions: ['30', '32', '34', '36'],
    category: 'Gaming',
    GPU: 'AMD 5800',
  },
  {
    id: 10,
    name: 'Gradient Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.5,
    totalReviews: 25,
    colorOptions: ['#000000', '#f0f0f0'],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'NVidia 2090',
  },
  {
    id: 11,
    name: 'Polo with Tipping Details',
    imageUrl: product,
    price: 180,
    rating: 4.8,
    totalReviews: 32,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Gaming',
    GPU: 'Amd 7800',
  },
  {
    id: 12,
    name: 'Black Striped T-shirt',
    imageUrl: product,
    price: 150,
    discountedPrice: 120,
    rating: 4.2,
    totalReviews: 18,
    colorOptions: ['#ffffff'],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'NVidia 4090',
  },
  {
    id: 13,
    name: 'Skinny Fit Jeans',
    imageUrl: product,
    price: 260,
    discountedPrice: 240,
    rating: 4.0,
    totalReviews: 45,
    sizeOptions: ['28', '30', '32', '34'],
    category: 'Office',
    GPU: 'NVidia 5090',
  },
  {
    id: 14,
    name: 'Checkered Shirt',
    imageUrl: product,
    price: 180,
    rating: 4.5,
    totalReviews: 28,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'AMD 7700',
  },
  {
    id: 15,
    name: 'Sleeve Striped T-shirt',
    imageUrl: product,
    price: 160,
    discountedPrice: 130,
    rating: 4.6,
    totalReviews: 22,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'School',
    GPU: 'AMD 7800',
  },
  {
    id: 16,
    name: 'Vertical Striped Shirt',
    imageUrl: product,
    price: 232,
    discountedPrice: 212,
    rating: 4.0,
    totalReviews: 15,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L'],
    category: 'School',
    GPU: 'AMD 7900',
  },
  {
    id: 17,
    name: 'Courage Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.0,
    totalReviews: 10,
    colorOptions: [],
    sizeOptions: ['M', 'L'],
    category: 'School',
    GPU: 'AMD 5600',
  },
  {
    id: 18,
    name: 'Loose Fit Bermuda Shorts',
    imageUrl: product,
    price: 80,
    rating: 3.8,
    totalReviews: 8,
    sizeOptions: ['30', '32', '34', '36'],
    category: 'Gaming',
    GPU: 'AMD 5800',
  },
  {
    id: 10,
    name: 'Gradient Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.5,
    totalReviews: 25,
    colorOptions: ['#000000', '#f0f0f0'],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'NVidia 2090',
  },
  {
    id: 11,
    name: 'Polo with Tipping Details',
    imageUrl: product,
    price: 180,
    rating: 4.8,
    totalReviews: 32,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Gaming',
    GPU: 'Amd 7800',
  },
  {
    id: 12,
    name: 'Black Striped T-shirt',
    imageUrl: product,
    price: 150,
    discountedPrice: 120,
    rating: 4.2,
    totalReviews: 18,
    colorOptions: ['#ffffff'],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'NVidia 4090',
  },
  {
    id: 13,
    name: 'Skinny Fit Jeans',
    imageUrl: product,
    price: 260,
    discountedPrice: 240,
    rating: 4.0,
    totalReviews: 45,
    sizeOptions: ['28', '30', '32', '34'],
    category: 'Office',
    GPU: 'NVidia 5090',
  },
  {
    id: 14,
    name: 'Checkered Shirt',
    imageUrl: product,
    price: 180,
    rating: 4.5,
    totalReviews: 28,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'AMD 7700',
  },
  {
    id: 15,
    name: 'Sleeve Striped T-shirt',
    imageUrl: product,
    price: 160,
    discountedPrice: 130,
    rating: 4.6,
    totalReviews: 22,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'School',
    GPU: 'AMD 7800',
  },
  {
    id: 16,
    name: 'Vertical Striped Shirt',
    imageUrl: product,
    price: 232,
    discountedPrice: 212,
    rating: 4.0,
    totalReviews: 15,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L'],
    category: 'School',
    GPU: 'AMD 7900',
  },
  {
    id: 17,
    name: 'Courage Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.0,
    totalReviews: 10,
    colorOptions: [],
    sizeOptions: ['M', 'L'],
    category: 'School',
    GPU: 'AMD 5600',
  },
  {
    id: 18,
    name: 'Loose Fit Bermuda Shorts',
    imageUrl: product,
    price: 80,
    rating: 3.8,
    totalReviews: 8,
    sizeOptions: ['30', '32', '34', '36'],
    category: 'Gaming',
    GPU: 'AMD 5800',
  },
  {
    id: 10,
    name: 'Gradient Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.5,
    totalReviews: 25,
    colorOptions: ['#000000', '#f0f0f0'],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'NVidia 2090',
  },
  {
    id: 11,
    name: 'Polo with Tipping Details',
    imageUrl: product,
    price: 180,
    rating: 4.8,
    totalReviews: 32,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Gaming',
    GPU: 'Amd 7800',
  },
  {
    id: 12,
    name: 'Black Striped T-shirt',
    imageUrl: product,
    price: 150,
    discountedPrice: 120,
    rating: 4.2,
    totalReviews: 18,
    colorOptions: ['#ffffff'],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'NVidia 4090',
  },
  {
    id: 13,
    name: 'Skinny Fit Jeans',
    imageUrl: product,
    price: 260,
    discountedPrice: 240,
    rating: 4.0,
    totalReviews: 45,
    sizeOptions: ['28', '30', '32', '34'],
    category: 'Office',
    GPU: 'NVidia 5090',
  },
  {
    id: 14,
    name: 'Checkered Shirt',
    imageUrl: product,
    price: 180,
    rating: 4.5,
    totalReviews: 28,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'AMD 7700',
  },
  {
    id: 15,
    name: 'Sleeve Striped T-shirt',
    imageUrl: product,
    price: 160,
    discountedPrice: 130,
    rating: 4.6,
    totalReviews: 22,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'School',
    GPU: 'AMD 7800',
  },
  {
    id: 16,
    name: 'Vertical Striped Shirt',
    imageUrl: product,
    price: 232,
    discountedPrice: 212,
    rating: 4.0,
    totalReviews: 15,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L'],
    category: 'School',
    GPU: 'AMD 7900',
  },
  {
    id: 17,
    name: 'Courage Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.0,
    totalReviews: 10,
    colorOptions: [],
    sizeOptions: ['M', 'L'],
    category: 'School',
    GPU: 'AMD 5600',
  },
  {
    id: 18,
    name: 'Loose Fit Bermuda Shorts',
    imageUrl: product,
    price: 80,
    rating: 3.8,
    totalReviews: 8,
    sizeOptions: ['30', '32', '34', '36'],
    category: 'Gaming',
    GPU: 'AMD 5800',
  },
  {
    id: 10,
    name: 'Gradient Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.5,
    totalReviews: 25,
    colorOptions: ['#000000', '#f0f0f0'],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'NVidia 2090',
  },
  {
    id: 11,
    name: 'Polo with Tipping Details',
    imageUrl: product,
    price: 180,
    rating: 4.8,
    totalReviews: 32,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Gaming',
    GPU: 'Amd 7800',
  },
  {
    id: 12,
    name: 'Black Striped T-shirt',
    imageUrl: product,
    price: 150,
    discountedPrice: 120,
    rating: 4.2,
    totalReviews: 18,
    colorOptions: ['#ffffff'],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'NVidia 4090',
  },
  {
    id: 13,
    name: 'Skinny Fit Jeans',
    imageUrl: product,
    price: 260,
    discountedPrice: 240,
    rating: 4.0,
    totalReviews: 45,
    sizeOptions: ['28', '30', '32', '34'],
    category: 'Office',
    GPU: 'NVidia 5090',
  },
  {
    id: 14,
    name: 'Checkered Shirt',
    imageUrl: product,
    price: 180,
    rating: 4.5,
    totalReviews: 28,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'AMD 7700',
  },
  {
    id: 15,
    name: 'Sleeve Striped T-shirt',
    imageUrl: product,
    price: 160,
    discountedPrice: 130,
    rating: 4.6,
    totalReviews: 22,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'School',
    GPU: 'AMD 7800',
  },
  {
    id: 16,
    name: 'Vertical Striped Shirt',
    imageUrl: product,
    price: 232,
    discountedPrice: 212,
    rating: 4.0,
    totalReviews: 15,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L'],
    category: 'School',
    GPU: 'AMD 7900',
  },
  {
    id: 17,
    name: 'Courage Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.0,
    totalReviews: 10,
    colorOptions: [],
    sizeOptions: ['M', 'L'],
    category: 'School',
    GPU: 'AMD 5600',
  },
  {
    id: 18,
    name: 'Loose Fit Bermuda Shorts',
    imageUrl: product,
    price: 80,
    rating: 3.8,
    totalReviews: 8,
    sizeOptions: ['30', '32', '34', '36'],
    category: 'Gaming',
    GPU: 'AMD 5800',
  },
  {
    id: 1,
    name: 'Gradient Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.5,
    totalReviews: 25,
    colorOptions: ['#000000', '#f0f0f0'],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'NVidia 2090',
   },
   {
    id: 2,
    name: 'Polo with Tipping Details',
    imageUrl: product,
    price: 180,
    rating: 4.8,
    totalReviews: 32,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Office',
    GPU: 'Amd 7800',
   },
   {
    id: 3,
    name: 'Black Striped T-shirt',
    imageUrl: product,
    price: 150,
    discountedPrice: 120,
    rating: 4.2,
    totalReviews: 18,
    colorOptions: ['#ffffff'],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'Office',
    GPU: 'NVidia 4090',
   },
   {
    id: 4,
    name: 'Skinny Fit Jeans',
    imageUrl: product,
    price: 260,
    discountedPrice: 240,
    rating: 4.0,
    totalReviews: 45,
    sizeOptions: ['28', '30', '32', '34'],
    category: 'School',
    GPU: 'NVidia 5090',
   },
   {
    id: 5,
    name: 'Checkered Shirt',
    imageUrl: product,
    price: 180,
    rating: 4.5,
    totalReviews: 28,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L', 'XL'],
    category: 'School',
    GPU: 'AMD 7700',
   },
   {
    id: 6,
    name: 'Sleeve Striped T-shirt',
    imageUrl: product,
    price: 160,
    discountedPrice: 130,
    rating: 4.6,
    totalReviews: 22,
    colorOptions: [],
    sizeOptions: ['M', 'L', 'XL'],
    category: 'Office',
    GPU: 'AMD 7800',
   },
   {
    id: 7,
    name: 'Vertical Striped Shirt',
    imageUrl: product,
    price: 232,
    discountedPrice: 212,
    rating: 4.0,
    totalReviews: 15,
    colorOptions: [],
    sizeOptions: ['S', 'M', 'L'],
    category: 'Gaming',
    GPU: 'AMD 7900',
   },
   {
    id: 8,
    name: 'Courage Graphic T-shirt',
    imageUrl: product,
    price: 145,
    rating: 4.0,
    totalReviews: 10,
    colorOptions: [],
    sizeOptions: ['M', 'L'],
    category: 'Office',
    GPU: 'AMD 5600',
   },
   {
    id: 9,
    name: 'Loose Fit Bermuda Shorts',
    imageUrl: product,
    price: 80,
    rating: 3.8,
    totalReviews: 8,
    sizeOptions: ['30', '32', '34', '36'],
    category: 'Gaming',
    GPU: 'AMD 5800',
   },
   {
     id: 10,
     name: 'Gradient Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.5,
     totalReviews: 25,
     colorOptions: ['#000000', '#f0f0f0'],
     sizeOptions: ['S', 'M', 'L'],
     category: 'Gaming',
     GPU: 'NVidia 2090',
   },
   {
     id: 11,
     name: 'Polo with Tipping Details',
     imageUrl: product,
     price: 180,
     rating: 4.8,
     totalReviews: 32,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'Gaming',
     GPU: 'Amd 7800',
   },
   {
     id: 12,
     name: 'Black Striped T-shirt',
     imageUrl: product,
     price: 150,
     discountedPrice: 120,
     rating: 4.2,
     totalReviews: 18,
     colorOptions: ['#ffffff'],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'NVidia 4090',
   },
   {
     id: 13,
     name: 'Skinny Fit Jeans',
     imageUrl: product,
     price: 260,
     discountedPrice: 240,
     rating: 4.0,
     totalReviews: 45,
     sizeOptions: ['28', '30', '32', '34'],
     category: 'Office',
     GPU: 'NVidia 5090',
   },
   {
     id: 14,
     name: 'Checkered Shirt',
     imageUrl: product,
     price: 180,
     rating: 4.5,
     totalReviews: 28,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'AMD 7700',
   },
   {
     id: 15,
     name: 'Sleeve Striped T-shirt',
     imageUrl: product,
     price: 160,
     discountedPrice: 130,
     rating: 4.6,
     totalReviews: 22,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'School',
     GPU: 'AMD 7800',
   },
   {
     id: 16,
     name: 'Vertical Striped Shirt',
     imageUrl: product,
     price: 232,
     discountedPrice: 212,
     rating: 4.0,
     totalReviews: 15,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L'],
     category: 'School',
     GPU: 'AMD 7900',
   },
   {
     id: 17,
     name: 'Courage Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.0,
     totalReviews: 10,
     colorOptions: [],
     sizeOptions: ['M', 'L'],
     category: 'School',
     GPU: 'AMD 5600',
   },
   {
     id: 18,
     name: 'Loose Fit Bermuda Shorts',
     imageUrl: product,
     price: 80,
     rating: 3.8,
     totalReviews: 8,
     sizeOptions: ['30', '32', '34', '36'],
     category: 'Gaming',
     GPU: 'AMD 5800',
   },
   {
     id: 10,
     name: 'Gradient Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.5,
     totalReviews: 25,
     colorOptions: ['#000000', '#f0f0f0'],
     sizeOptions: ['S', 'M', 'L'],
     category: 'Gaming',
     GPU: 'NVidia 2090',
   },
   {
     id: 11,
     name: 'Polo with Tipping Details',
     imageUrl: product,
     price: 180,
     rating: 4.8,
     totalReviews: 32,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'Gaming',
     GPU: 'Amd 7800',
   },
   {
     id: 12,
     name: 'Black Striped T-shirt',
     imageUrl: product,
     price: 150,
     discountedPrice: 120,
     rating: 4.2,
     totalReviews: 18,
     colorOptions: ['#ffffff'],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'NVidia 4090',
   },
   {
     id: 13,
     name: 'Skinny Fit Jeans',
     imageUrl: product,
     price: 260,
     discountedPrice: 240,
     rating: 4.0,
     totalReviews: 45,
     sizeOptions: ['28', '30', '32', '34'],
     category: 'Office',
     GPU: 'NVidia 5090',
   },
   {
     id: 14,
     name: 'Checkered Shirt',
     imageUrl: product,
     price: 180,
     rating: 4.5,
     totalReviews: 28,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'AMD 7700',
   },
   {
     id: 15,
     name: 'Sleeve Striped T-shirt',
     imageUrl: product,
     price: 160,
     discountedPrice: 130,
     rating: 4.6,
     totalReviews: 22,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'School',
     GPU: 'AMD 7800',
   },
   {
     id: 16,
     name: 'Vertical Striped Shirt',
     imageUrl: product,
     price: 232,
     discountedPrice: 212,
     rating: 4.0,
     totalReviews: 15,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L'],
     category: 'School',
     GPU: 'AMD 7900',
   },
   {
     id: 17,
     name: 'Courage Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.0,
     totalReviews: 10,
     colorOptions: [],
     sizeOptions: ['M', 'L'],
     category: 'School',
     GPU: 'AMD 5600',
   },
   {
     id: 18,
     name: 'Loose Fit Bermuda Shorts',
     imageUrl: product,
     price: 80,
     rating: 3.8,
     totalReviews: 8,
     sizeOptions: ['30', '32', '34', '36'],
     category: 'Gaming',
     GPU: 'AMD 5800',
   },
   {
     id: 10,
     name: 'Gradient Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.5,
     totalReviews: 25,
     colorOptions: ['#000000', '#f0f0f0'],
     sizeOptions: ['S', 'M', 'L'],
     category: 'Gaming',
     GPU: 'NVidia 2090',
   },
   {
     id: 11,
     name: 'Polo with Tipping Details',
     imageUrl: product,
     price: 180,
     rating: 4.8,
     totalReviews: 32,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'Gaming',
     GPU: 'Amd 7800',
   },
   {
     id: 12,
     name: 'Black Striped T-shirt',
     imageUrl: product,
     price: 150,
     discountedPrice: 120,
     rating: 4.2,
     totalReviews: 18,
     colorOptions: ['#ffffff'],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'NVidia 4090',
   },
   {
     id: 13,
     name: 'Skinny Fit Jeans',
     imageUrl: product,
     price: 260,
     discountedPrice: 240,
     rating: 4.0,
     totalReviews: 45,
     sizeOptions: ['28', '30', '32', '34'],
     category: 'Office',
     GPU: 'NVidia 5090',
   },
   {
     id: 14,
     name: 'Checkered Shirt',
     imageUrl: product,
     price: 180,
     rating: 4.5,
     totalReviews: 28,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'AMD 7700',
   },
   {
     id: 15,
     name: 'Sleeve Striped T-shirt',
     imageUrl: product,
     price: 160,
     discountedPrice: 130,
     rating: 4.6,
     totalReviews: 22,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'School',
     GPU: 'AMD 7800',
   },
   {
     id: 16,
     name: 'Vertical Striped Shirt',
     imageUrl: product,
     price: 232,
     discountedPrice: 212,
     rating: 4.0,
     totalReviews: 15,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L'],
     category: 'School',
     GPU: 'AMD 7900',
   },
   {
     id: 17,
     name: 'Courage Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.0,
     totalReviews: 10,
     colorOptions: [],
     sizeOptions: ['M', 'L'],
     category: 'School',
     GPU: 'AMD 5600',
   },
   {
     id: 18,
     name: 'Loose Fit Bermuda Shorts',
     imageUrl: product,
     price: 80,
     rating: 3.8,
     totalReviews: 8,
     sizeOptions: ['30', '32', '34', '36'],
     category: 'Gaming',
     GPU: 'AMD 5800',
   },
   {
     id: 10,
     name: 'Gradient Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.5,
     totalReviews: 25,
     colorOptions: ['#000000', '#f0f0f0'],
     sizeOptions: ['S', 'M', 'L'],
     category: 'Gaming',
     GPU: 'NVidia 2090',
   },
   {
     id: 11,
     name: 'Polo with Tipping Details',
     imageUrl: product,
     price: 180,
     rating: 4.8,
     totalReviews: 32,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'Gaming',
     GPU: 'Amd 7800',
   },
   {
     id: 12,
     name: 'Black Striped T-shirt',
     imageUrl: product,
     price: 150,
     discountedPrice: 120,
     rating: 4.2,
     totalReviews: 18,
     colorOptions: ['#ffffff'],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'NVidia 4090',
   },
   {
     id: 13,
     name: 'Skinny Fit Jeans',
     imageUrl: product,
     price: 260,
     discountedPrice: 240,
     rating: 4.0,
     totalReviews: 45,
     sizeOptions: ['28', '30', '32', '34'],
     category: 'Office',
     GPU: 'NVidia 5090',
   },
   {
     id: 14,
     name: 'Checkered Shirt',
     imageUrl: product,
     price: 180,
     rating: 4.5,
     totalReviews: 28,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'AMD 7700',
   },
   {
     id: 15,
     name: 'Sleeve Striped T-shirt',
     imageUrl: product,
     price: 160,
     discountedPrice: 130,
     rating: 4.6,
     totalReviews: 22,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'School',
     GPU: 'AMD 7800',
   },
   {
     id: 16,
     name: 'Vertical Striped Shirt',
     imageUrl: product,
     price: 232,
     discountedPrice: 212,
     rating: 4.0,
     totalReviews: 15,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L'],
     category: 'School',
     GPU: 'AMD 7900',
   },
   {
     id: 17,
     name: 'Courage Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.0,
     totalReviews: 10,
     colorOptions: [],
     sizeOptions: ['M', 'L'],
     category: 'School',
     GPU: 'AMD 5600',
   },
   {
     id: 18,
     name: 'Loose Fit Bermuda Shorts',
     imageUrl: product,
     price: 80,
     rating: 3.8,
     totalReviews: 8,
     sizeOptions: ['30', '32', '34', '36'],
     category: 'Gaming',
     GPU: 'AMD 5800',
   },
   {
     id: 10,
     name: 'Gradient Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.5,
     totalReviews: 25,
     colorOptions: ['#000000', '#f0f0f0'],
     sizeOptions: ['S', 'M', 'L'],
     category: 'Gaming',
     GPU: 'NVidia 2090',
   },
   {
     id: 11,
     name: 'Polo with Tipping Details',
     imageUrl: product,
     price: 180,
     rating: 4.8,
     totalReviews: 32,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'Gaming',
     GPU: 'Amd 7800',
   },
   {
     id: 12,
     name: 'Black Striped T-shirt',
     imageUrl: product,
     price: 150,
     discountedPrice: 120,
     rating: 4.2,
     totalReviews: 18,
     colorOptions: ['#ffffff'],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'NVidia 4090',
   },
   {
     id: 13,
     name: 'Skinny Fit Jeans',
     imageUrl: product,
     price: 260,
     discountedPrice: 240,
     rating: 4.0,
     totalReviews: 45,
     sizeOptions: ['28', '30', '32', '34'],
     category: 'Office',
     GPU: 'NVidia 5090',
   },
   {
     id: 14,
     name: 'Checkered Shirt',
     imageUrl: product,
     price: 180,
     rating: 4.5,
     totalReviews: 28,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'AMD 7700',
   },
   {
     id: 15,
     name: 'Sleeve Striped T-shirt',
     imageUrl: product,
     price: 160,
     discountedPrice: 130,
     rating: 4.6,
     totalReviews: 22,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'School',
     GPU: 'AMD 7800',
   },
   {
     id: 16,
     name: 'Vertical Striped Shirt',
     imageUrl: product,
     price: 232,
     discountedPrice: 212,
     rating: 4.0,
     totalReviews: 15,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L'],
     category: 'School',
     GPU: 'AMD 7900',
   },
   {
     id: 17,
     name: 'Courage Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.0,
     totalReviews: 10,
     colorOptions: [],
     sizeOptions: ['M', 'L'],
     category: 'School',
     GPU: 'AMD 5600',
   },
   {
     id: 18,
     name: 'Loose Fit Bermuda Shorts',
     imageUrl: product,
     price: 80,
     rating: 3.8,
     totalReviews: 8,
     sizeOptions: ['30', '32', '34', '36'],
     category: 'Gaming',
     GPU: 'AMD 5800',
   },
   {
     id: 10,
     name: 'Gradient Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.5,
     totalReviews: 25,
     colorOptions: ['#000000', '#f0f0f0'],
     sizeOptions: ['S', 'M', 'L'],
     category: 'Gaming',
     GPU: 'NVidia 2090',
   },
   {
     id: 11,
     name: 'Polo with Tipping Details',
     imageUrl: product,
     price: 180,
     rating: 4.8,
     totalReviews: 32,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'Gaming',
     GPU: 'Amd 7800',
   },
   {
     id: 12,
     name: 'Black Striped T-shirt',
     imageUrl: product,
     price: 150,
     discountedPrice: 120,
     rating: 4.2,
     totalReviews: 18,
     colorOptions: ['#ffffff'],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'NVidia 4090',
   },
   {
     id: 13,
     name: 'Skinny Fit Jeans',
     imageUrl: product,
     price: 260,
     discountedPrice: 240,
     rating: 4.0,
     totalReviews: 45,
     sizeOptions: ['28', '30', '32', '34'],
     category: 'Office',
     GPU: 'NVidia 5090',
   },
   {
     id: 14,
     name: 'Checkered Shirt',
     imageUrl: product,
     price: 180,
     rating: 4.5,
     totalReviews: 28,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L', 'XL'],
     category: 'Office',
     GPU: 'AMD 7700',
   },
   {
     id: 15,
     name: 'Sleeve Striped T-shirt',
     imageUrl: product,
     price: 160,
     discountedPrice: 130,
     rating: 4.6,
     totalReviews: 22,
     colorOptions: [],
     sizeOptions: ['M', 'L', 'XL'],
     category: 'School',
     GPU: 'AMD 7800',
   },
   {
     id: 16,
     name: 'Vertical Striped Shirt',
     imageUrl: product,
     price: 232,
     discountedPrice: 212,
     rating: 4.0,
     totalReviews: 15,
     colorOptions: [],
     sizeOptions: ['S', 'M', 'L'],
     category: 'School',
     GPU: 'AMD 7900',
   },
   {
     id: 17,
     name: 'Courage Graphic T-shirt',
     imageUrl: product,
     price: 145,
     rating: 4.0,
     totalReviews: 10,
     colorOptions: [],
     sizeOptions: ['M', 'L'],
     category: 'School',
     GPU: 'AMD 5600',
   },
   {
     id: 18,
     name: 'Loose Fit Bermuda Shorts',
     imageUrl: product,
     price: 80,
     rating: 3.8,
     totalReviews: 8,
     sizeOptions: ['30', '32', '34', '36'],
     category: 'Gaming',
     GPU: 'AMD 5800',
   },
  // ... more products
 ];

 interface FilterState {
  priceRange: number[];
  colors: string[];
  sizes: string[];
  GPU: string[];
  categories: string[];
 }

 const ShopPage: React.FC = () => {
  const [products, setProducts] = useState<Product[]>(sampleProducts);
  const [filters, setFilters] = useState<FilterState>({
   priceRange: [50, 200],
   colors: [],
   sizes: [],
   GPU: [],
   categories: [],
  });
  const [sortBy, setSortBy] = useState<string>('Most Popular');
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 9;
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const availableColors = Array.from(new Set(sampleProducts.flatMap((p) => p.colorOptions || [])));
  const availableSizes = Array.from(new Set(sampleProducts.flatMap((p) => p.sizeOptions || [])));
  const availableDressStyles = Array.from(new Set(sampleProducts.map((p) => p.GPU).filter((s) => !!s) as string[]));
  const availableCategories = Array.from(new Set(sampleProducts.map((p) => p.category)));

  const filteredProducts = products.filter((product) => {
   const priceFilter = product.price >= filters.priceRange[0] && product.price <= filters.priceRange[1];
   const colorFilter = filters.colors.length === 0 || (product.colorOptions || []).some((color) => filters.colors.includes(color));
   const sizeFilter = filters.sizes.length === 0 || (product.sizeOptions || []).some((size) => filters.sizes.includes(size));
   const dressStyleFilter = filters.GPU.length === 0 || (product.GPU && filters.GPU.includes(product.GPU));
   const categoryFilter = filters.categories.length === 0 || filters.categories.includes(product.category);
   return priceFilter && colorFilter && sizeFilter && dressStyleFilter && categoryFilter;
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
   if (sortBy === 'Price: Low to High') return a.price - b.price;
   if (sortBy === 'Price: High to Low') return b.price - a.price;
   if (sortBy === 'Top Rated') return b.rating - a.rating;
   return 0;
  });

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = sortedProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  useEffect(() => {
      const className = 'disable-body-scroll';
  
      if (showMobileFilters) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
  
      // Optional cleanup if needed
      return () => {
        document.body.classList.remove(className);
      };
    }, [showMobileFilters]);

  const handlePriceChange = (event: ChangeEvent<HTMLInputElement>, newValue: number[]) => {
   setFilters({ ...filters, priceRange: newValue });
  };

  const handleColorChange = (color: string) => {
   setFilters({
    ...filters,
    colors: filters.colors.includes(color) ? filters.colors.filter((c) => c !== color) : [...filters.colors, color],
   });
  };

  const handleSizeChange = (size: string) => {
   setFilters({
    ...filters,
    sizes: filters.sizes.includes(size) ? filters.sizes.filter((s) => s !== size) : [...filters.sizes, size],
   });
  };

  const handleDressStyleChange = (style: string) => {
   setFilters({
    ...filters,
    GPU: filters.GPU.includes(style) ? filters.GPU.filter((ds) => ds !== style) : [...filters.GPU, style],
   });
  };

  const handleCategoryChange = (category: string) => {
   setFilters({
    ...filters,
    categories: filters.categories.includes(category) ? filters.categories.filter((cat) => cat !== category) : [...filters.categories, category],
   });
  };

  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
   setSortBy(event.target.value);
   setCurrentPage(1);
  };

  const handleApplyFilters = () => {
   setCurrentPage(1);
   setShowMobileFilters(false);
   console.log('Applied Filters:', filters);
  };

  const handleResetFilters = () => {
   setFilters({
    priceRange: [50, 200],
    colors: [],
    sizes: [],
    GPU: [],
    categories: [],
   });
   setCurrentPage(1);
  };

  useEffect(() => {
   const handleResize = () => {
    setIsMobile(window.innerWidth < 800); // Adjust breakpoint as needed
   };

   handleResize();
   window.addEventListener('resize', handleResize);

   return () => {
    window.removeEventListener('resize', handleResize);
   };
  }, []);

  return (
   <div className="container mx-auto flex flex-col md:flex-row gap-6 p-6 mb-20">
    {/* Mobile Filters Modal */}
    {isMobile && showMobileFilters && (
     <div className="fixed top-0 left-0 w-full h-full bg-white z-[101] overflow-y-auto p-6">
      <div className="flex justify-between items-center mb-4">
       <h2 className="text-lg font-semibold">Filters</h2>
       <button onClick={() => setShowMobileFilters(false)} className="text-gray-500 hover:text-gray-700">
        <X className="h-6 w-6" />
       </button>
      </div>

      {/* Categories Filter */}
      <div className="mb-4">
       <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
        Categories
        <ChevronDown className="h-4 w-4 opacity-60" />
       </h3>
       <ul>
        {availableCategories.map((category) => (
         <li key={category} className="py-1 flex items-center">
          <input
           type="checkbox"
           id={`mobile-category-${category}`}
           className="mr-2 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
           checked={filters.categories.includes(category)}
           onChange={() => handleCategoryChange(category)}
          />
          <label htmlFor={`mobile-category-${category}`} className="text-sm text-gray-700">{category}</label>
         </li>
        ))}
       </ul>
      </div>

      {/* Price Filter */}
      <div className="mb-4">
       <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
        Price
        <ChevronDown className="h-4 w-4 opacity-60" />
       </h3>
       <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
        <span>$50</span>
        <span>$200</span>
       </div>
       <input
        type="range"
        className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
        min="50"
        max="200"
        step="10"
        value={filters.priceRange[1]}
        onChange={(e) => handlePriceChange(e, [filters.priceRange[0], parseInt(e.target.value)])}
       />
       <input
        type="range"
        className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700 mt-2"
        min="50"
        max="200"
        step="10"
        value={filters.priceRange[0]}
        onChange={(e) => handlePriceChange(e, [parseInt(e.target.value), filters.priceRange[1]])}
       />
       <div className="flex items-center justify-between text-sm text-gray-700 mt-2">
        <span>${filters.priceRange[0]}</span>
        <span>${filters.priceRange[1]}</span>
       </div>
      </div>

      {/* Colors Filter */}
      <div className="mb-4">
       <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
        Colors
        <ChevronDown className="h-4 w-4 opacity-60" />
       </h3>
       <div className="flex flex-wrap gap-2">
        {availableColors.map((color) => (
         <button
          key={color}
          className={`w-8 h-8 rounded-full cursor-pointer shadow-sm focus:outline-none border-2 border-[#ffffff] ${
           filters.colors.includes(color) ? 'ring-2 ring-indigo-500' : ''
          }`}
          style={{ backgroundColor: color }}
          onClick={() => handleColorChange(color)}
         >
          {filters.colors.includes(color) && <Check className="h-5 w-5 text-white" />}
         </button>
        ))}
       </div>
      </div>

      {/* Size Filter */}
      <div className="mb-4">
       <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
        Size
        <ChevronDown className="h-4 w-4 opacity-60" />
       </h3>
       <div className="grid grid-cols-3 gap-2">
        {availableSizes.map((size) => (
         <button
          key={size}
          className={`px-3 py-1 rounded-md border border-gray-300 text-sm text-gray-700 focus:outline-none ${
           filters.sizes.includes(size) ? 'bg-gray-200' : ''
          }`}
          onClick={() => handleSizeChange(size)}
         >
          {size}
         </button>
        ))}
       </div>
      </div>

      {/* Dress Style Filter */}
      <div className="mb-4">
       <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
        Graphics Card
        <ChevronDown className="h-4 w-4 opacity-60" />
       </h3>
       <ul>
        {availableDressStyles.map((style) => (
         <li key={style} className="py-1 flex items-center">
          <input
           type="checkbox"
           id={`mobile-dress-style-${style}`}
           className="mr-2 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
           checked={filters.GPU.includes(style)}
           onChange={() => handleDressStyleChange(style)}
          />
          <label htmlFor={`mobile-dress-style-${style}`} className="text-sm text-gray-700">{style}</label>
         </li>
        ))}
       </ul>
      </div>

      <div className="flex justify-between mt-8">
       <button
        onClick={handleResetFilters}
        className="px-4 py-2 rounded-md text-gray-700 border border-gray-300 hover:bg-gray-100 focus:outline-none"
       >
        Reset
       </button>
       <button
        onClick={handleApplyFilters}
        className="bg-[#ff9900] text-white py-2 px-4 rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
       >
        Apply Filters
       </button>
      </div>
     </div>
    )}

    {/* Filters Sidebar (Desktop) */}
    {!isMobile && (
     <aside className="w-64">
      <div className='sticky top-[80px]'>
       <div className="mb-4">
        <h2 className="text-lg font-semibold">Filters</h2>
       </div>

       {/* Categories Filter */}
       <div className="mb-4">
        <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
         Categories
         <ChevronDown className="h-4 w-4 opacity-60" />
        </h3>
        <ul>
         {availableCategories.map((category) => (
          <li key={category} className="py-1 flex items-center">
           <input
            type="checkbox"
            id={`category-${category}`}
            className="mr-2 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            checked={filters.categories.includes(category)}
            onChange={() => handleCategoryChange(category)}
           />
           <label htmlFor={`category-${category}`} className="text-sm text-gray-700">{category}</label>
          </li>
         ))}
        </ul>
       </div>

       {/* Price Filter */}
       <div className="mb-4">
        <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
         Price
         <ChevronDown className="h-4 w-4 opacity-60" />
        </h3>
        <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
         <span>$50</span>
         <span>$200</span>
        </div>
        <input
         type="range"
         className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
         min="50"
         max="200"
         step="10"
         value={filters.priceRange[1]}
         onChange={(e) => handlePriceChange(e, [filters.priceRange[0], parseInt(e.target.value)])}
        />
        <input
         type="range"
         className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700 mt-2"
         min="50"
         max="200"
         step="10"
         value={filters.priceRange[0]}
         onChange={(e) => handlePriceChange(e, [parseInt(e.target.value), filters.priceRange[1]])}
        />
        <div className="flex items-center justify-between text-sm text-gray-700 mt-2">
         <span>${filters.priceRange[0]}</span>
         <span>${filters.priceRange[1]}</span>
        </div>
       </div>

       {/* Colors Filter */}
       <div className="mb-4">
        <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
         Colors
         <ChevronDown className="h-4 w-4 opacity-60" />
        </h3>
        <div className="flex flex-wrap gap-2">
         {availableColors.map((color) => (
          <button
           key={color}
           className={`w-6 h-6 rounded-full cursor-pointer shadow-sm focus:outline-none border-2 border-[#ffffff] ${
            filters.colors.includes(color) ? 'ring-2 ring-indigo-500' : ''
           }`}
           style={{ backgroundColor: color }}
           onClick={() => handleColorChange(color)}
          >
           {filters.colors.includes(color) && <Check className="h-4 w-4 text-white" />}
          </button>
         ))}
        </div>
       </div>

       {/* Size Filter */}
       <div className="mb-4">
        <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
         Size
         <ChevronDown className="h-4 w-4 opacity-60" />
        </h3>
        <div className="grid grid-cols-3 gap-2">
         {availableSizes.map((size) => (
          <button
           key={size}
           className={`px-2 py-1 rounded-md border border-gray-300 text-sm text-gray-700 focus:outline-none ${
            filters.sizes.includes(size) ? 'bg-gray-200' : ''
           }`}
           onClick={() => handleSizeChange(size)}
          >
           {size}
          </button>
         ))}
        </div>
       </div>

       {/* Dress Style Filter */}
       <div className="mb-4">
        <h3 className="text-md font-semibold mb-2 flex items-center justify-between">
         Dress Style
         <ChevronDown className="h-4 w-4 opacity-60" />
        </h3>
        <ul>
         {availableDressStyles.map((style) => (
          <li key={style} className="py-1 flex items-center">
           <input
            type="checkbox"
            id={`dress-style-${style}`}
            className="mr-2 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            checked={filters.GPU.includes(style)}
            onChange={() => handleDressStyleChange(style)}
           />
           <label htmlFor={`dress-style-${style}`} className="text-sm text-gray-700">{style}</label>
          </li>
         ))}
        </ul>
       </div>
      </div>
     </aside>
    )}

    {/* Product Listing Area */}
    <main className="flex-1">
     <div className="flex items-center justify-between mb-4 flex-row shop-header">
      <h2 className="text-xl font-semibold self-start ">Computers</h2>
      <p className="text-sm text-gray-600 hidden sm:flex">
       Showing {indexOfFirstProduct + 1}-{Math.min(indexOfLastProduct, filteredProducts.length)} of {filteredProducts.length} products
      </p>
      <div className="relative flex flex-row w-auto justify-between utils-wrapper">
        {isMobile && (
          <div className="relative mr-3">
            <button
              onClick={() => setShowMobileFilters(true)}
              className="bg-white text-black py-2 px-2 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
            <SlidersHorizontal className="h-5 w-5 inline-block" />
            </button>
          </div>
        )}
       <select
        value={sortBy}
        onChange={handleSortChange}
        className="block appearance-none bg-white border border-gray-300 hover:border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-sm"
       >
        <option value="Most Popular">Most Popular</option>
        <option value="Price: Low to High">Price: Low to High</option>
        <option value="Price: High to Low">Price: High to Low</option>
        <option value="Top Rated">Top Rated</option>
       </select>
       <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <ChevronDown className="h-4 w-4" />
       </div>
      </div>
     </div>

     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {currentProducts.map((product) => (
       <Link to='/computers/zeus-max'>
        <div key={product.id} className="bg-white rounded-md shadow-md overflow-hidden cursor-pointer">
          <img src={product.imageUrl} alt={product.name} className="w-full h-48 object-contain" />
          <div className="p-4">
          <h3 className="text-md font-semibold text-gray-800 text-center">{product.name}</h3>
          <div className="flex items-center justify-center mt-2">
            {product.discountedPrice ? (
            <>
              <span className="text-sm text-gray-600 line-through">${product.price}</span><span className="ml-2 text-lg font-semibold text-red-600">${product.discountedPrice}</span>
            </>
            ) : (
            <span className="text-lg font-semibold text-gray-800">${product.price}</span>
            )}
          </div>
          <div className="flex items-center justify-center mt-1">
            {[...Array(Math.floor(product.rating))].map((_, index) => (
              <svg
                key={`full-${index}`}
                className="w-4 h-4 fill-current text-yellow-500"
                viewBox="0 0 20 20"
              >
                <path
                  d="M10 15l-5.878 3.09 1.176-6.545L.587 6.95l6.545-.943L10 0l2.868 6.007 6.545.943L14.702 11.545l1.176 6.545z"
                />
              </svg>
            ))}
            {[...Array(5 - Math.floor(product.rating))].map((_, index) => (
              <svg
                className="w-4 h-4 fill-current text-yellow-500"
                viewBox="0 0 20 20"
              >
                <path
                d="M11 2L14 8H20L15 11L17 17L11 14L5 17L7 11L2 8H8L11 2Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                />
              </svg>
            ))}
            <span className="text-xs text-gray-500 ml-1">({product.totalReviews})</span>
          </div>
          </div>
        </div>
      </Link>
      ))}
     </div>

     {/* Pagination */}
    {filteredProducts.length > productsPerPage && (
      <div className="flex justify-center items-center mt-6">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="bg-white text-gray-700 border border-gray-300 rounded-l-md px-3 py-1.5 md:py-1 focus:outline-none hover:bg-gray-100 disabled:opacity-50 flex items-center"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          <span className="hidden sm:inline">Previous</span>
        </button>
        <div className="flex items-center">
          {Array.from({ length: Math.ceil(filteredProducts.length / productsPerPage) }, (_, i) => i + 1)
            .filter((page) => {
              const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
              if (totalPages <= 7) {
                return true;
              }
              if (page === 1 || page === totalPages || Math.abs(currentPage - page) <= 2) {
                return true;
              }
              return false;
            })
            .map((page, index, array) => (
              <React.Fragment key={page}>
                {index > 0 && page > array[index - 1] + 1 && <span className="px-2">...</span>}
                <button
                  onClick={() => paginate(page)}
                  className={`px-3 py-2 text-sm focus:outline-none ${
                    currentPage === page
                      ? 'bg-gray-800 text-white font-semibold'
                      : 'bg-white text-gray-700 border-y border-gray-300 first:border-l last:border-r hover:bg-gray-100'
                  }`}
                >
                  {page}
                </button>
              </React.Fragment>
            ))}
        </div>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredProducts.length / productsPerPage)))}
          disabled={currentPage === Math.ceil(filteredProducts.length / productsPerPage)}
          className="bg-white text-gray-700 border border-gray-300 rounded-r-md px-3 py-1.5 md:py-1 focus:outline-none hover:bg-gray-100 disabled:opacity-50 flex items-center"
        >
          <span className="hidden sm:inline">Next</span>
          <ArrowRight className="h-4 w-4 ml-1" />
        </button>
      </div>
    )}
    </main>
   </div>
  );
 };

 export default ShopPage;